import React from "react";
import "./BodyTemplateStyles.css";

export const vesselBodyTemplate = (
    rowData: any,
    selectVessel: (rowData: any) => void,
    isInteractive = true
) => {
    // eslint-disable-next-line no-prototype-builtins
    const name = rowData.hasOwnProperty("vesselName")
        ? rowData.vesselName
        : rowData.vessel.vesselName;
    // eslint-disable-next-line no-prototype-builtins
    const imoNum = rowData.hasOwnProperty("imo")
        ? rowData.imo
        : rowData.vessel.imo;

    const selectVesselIfAvailable = () => {
        selectVessel && selectVessel(rowData);
    };

    return (
        <div className="justify-content-start">
            <div>
                <p
                    className={isInteractive ? "vessel-name-table-cell" : ""}
                    onClick={
                        isInteractive
                            ? () => selectVesselIfAvailable()
                            : undefined
                    }
                >
                    {name}
                </p>
                <small>{imoNum}</small>
            </div>
        </div>
    );
};
